import { baseRequest } from "../../util/Api";
import { message } from "antd";
import { v4 } from "uuid";

export const getTrainingBundles = (filter) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/training-bundles", filter)
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}

export const getTrainingBundle = (id) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/training-bundles/" + id, null)
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}

export const getTrainingBundleParticipant = (training_option_id, ids) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/training-bundles/participant/" + training_option_id, { ids: ids.join(",") })
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}

export const createTrainingBundle = (trainingBundle) => {
  return new Promise((resolve) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Menyimpan Training Bundle ..." })
    baseRequest("post", "/training-bundles/", null, trainingBundle)
      .then((newData) => {
        message.success({ key, type: 'success', content: "Menyimpan Training Bundle berhasil" })
        resolve(newData);
      })
      .catch((e) => {
        message.error({ key, type: 'error', content: e })
      });
  });
}

export const updateTrainingBundle = (id, trainingBundle) => {
  return new Promise((resolve) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Menyimpan Training Bundle ..." })
    baseRequest("put", "/training-bundles/" + id, null, trainingBundle)
      .then((newData) => {
        message.success({ key, type: 'success', content: "Menyimpan Training Bundle berhasil" })
        resolve(newData);
      })
      .catch((e) => {
        message.error({ key, type: 'error', content: e })
      });
  });
}

export const patchTrainingBundle = (id, trainingBundle) => {
  return new Promise((resolve) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Menyimpan Training Bundle ..." })
    baseRequest("patch", "/training-bundles/" + id, null, trainingBundle)
      .then((newData) => {
        message.success({ key, type: 'success', content: "Menyimpan Training Bundle berhasil" })
        resolve(newData);
      })
      .catch((e) => {
        message.error({ key, type: 'error', content: e })
      });
  });
}

export const deleteTrainingBundle = (id) => {
  return new Promise((resolve, reject) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Menghapus Training Bundle ..." })
    baseRequest("delete", "/training-bundles/" + id, null)
      .then((data) => {
        message.success({ key, type: 'success', content: "Menghapus Training Bundle berhasil" })
        resolve(data)
      }).catch((e) => {
        message.error({ key, type: 'error', content: e })
      })
  })
}